import axios from 'axios';
import moment from 'moment';
import Rnd from './Rnd';

export default class BackendProxy {
  constructor() {
    BackendProxy.instance = this;


    this.cityMap = {};
    this.citiesByDate = [];
    //
    // if (process.env.NODE_ENV == 'development') {
    //   // BackendProxy.url = 'http://192.168.178.74:13000';
    //   BackendProxy.url = 'http://192.168.0.81:13000';
    //   // BackendProxy.url = 'http://localhost:13000';
    //   // BackendProxy.url = 'https://api.smart.electronauts.net';
    // } else {
    //   BackendProxy.url = 'https://api.smart.electronauts.net';
    // }
  }

  init() {

    if (process.env.NODE_ENV == 'development') {
      return new Promise((resolve, reject) => {
        axios.get(`${BackendProxy.url}/data/cms`)
          .then(response => {
            const payload = response.data.payload;
            console.log(response.data.payload);
            this.cities = payload.cities;
            this.layout = this.createLayoutData(payload.pages);
            this.settings = payload.settings;
            this.instagramTagPrefix = payload.tag;
            this.instagramUser = payload.user;
            this.activeCityKey = payload.activeCity;
            this.mapStyle = payload.mapStyle;
            this.maxScore = payload.maxScore;
            this.findStartDate();

            // setInterval(()=>{
            //   axios.get(`${BackendProxy.url}/data/cms`)
            //     .then(response => {
            //       console.log(response);
            //       this.cities = response.data.payload.cities;
            //     })
            // }, 1000);

            //
            // axios.get(`https://api.smart.electronauts.net/data/pages.json?${Date.now()}`)
            //   .then((r) => {
            //     console.log(r.data);
            //     this.layout = this.createLayoutData(r.data);
            //     resolve();
            //   });

            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        axios.all([
          axios.get(`${BackendProxy.url}/data/pages.json?${Date.now()}`),
          axios.get(`${BackendProxy.url}/data/settings`),
        ])
          .then(axios.spread((pages, settings) => {
            this.layout = this.createLayoutData(pages.data);
            this.settings = settings.data.payload;
            this.cities = this.settings.cities;
            this.instagramTagPrefix = this.settings.tag;
            this.instagramUser = this.settings.user;
            this.activeCityKey = this.settings.activeCity;
            this.mapStyle = this.settings.mapStyle;
            this.maxScore = this.settings.maxScore;
            this.findStartDate();
            resolve();
          }))
          .catch(e => {
            reject(e);
          });
      });
    }
  }

  getCityData(cityKey) {
    return this.cityMap[cityKey];
  }

  getLayout(page) {
    return this.layout[page];
  }

  getInstagramPlaceHolders() {
    const list = this.settings.instagram.placeholders;
    return list;
  }

  getNextActiveCity(nowMillis) {
    nowMillis = nowMillis || Date.now();
    const cities = this.citiesByDate;
    const l = cities.length;
    for (let i = -1; i < l; i++) {
      if (i + 1 < l) {
        const nextCity = cities[i + 1];
        if (nowMillis < nextCity.startDateMillis) {
          return nextCity
        }
      }
    }
    return null;
  }

  getActiveCity(nowMillis) {
    nowMillis = nowMillis || Date.now();
    const l = this.citiesByDate.length;
    const day = 1000 * 60 * 60 * 24;
    for (let i = 0; i < l; i++) {
      const city = this.citiesByDate[i];
      if (nowMillis >= city.startDateMillis && nowMillis <= city.endDateMillis + day) {
        return city;
      }
    }
    return null;
  }

  _getInstagramPosts(cityKey) {
    return new Promise((resolve, reject) => {
      axios.get(`${BackendProxy.url}/posts/city/${cityKey}?count=12`)
        .then(response => {
          resolve(response.data.payload);
        })
        .catch(e => {
          reject();
        });
    });
  }

  getInstagramPosts(tag) {
    return new Promise((resolve, reject) => {
      axios.get(`${BackendProxy.url}/posts/${tag}?count=12`)
        .then(response => {
          resolve(response.data.payload);
        })
        .catch(e => {
          reject();
        });
    });
  }

  // *********************************************************************************************
  // * Private                                           																			   *
  // *********************************************************************************************
  createLayoutData(d) {
    const ret = {};
    for (let i = 0; i < d.length; i++) {
      const e = d[i];
      ret[e.key] = e;
    }
    return ret;
  }

  findStartDate() {

    // let score = this.settings.scores.maxTotalScore * 0.75;

    let t = Number.MAX_VALUE;
    for (let i = 0; i < this.cities.length; i++) {
      const city = this.cities[i];
      this.cityMap[city.key] = city;
      this.citiesByDate.push(city);
      city.dateString = moment(city.startDate).format('DD.MM.') + ' - ' + moment(city.endDate).format('DD.MM.YYYY');
      const t2 = moment(city.startDate).valueOf();
      if (t2 < t) {
        t = t2;
      }
      city.startDateMillis = t2;
      city.endDateMillis = moment(city.endDate).valueOf();
      city.startDateJS = new Date(t2);
      // city.score = score;
      // score -= 100;
    }

    this.citiesByDate.sort((a, b) => {
      return a.startDateMillis - b.startDateMillis
    });

    this.startDate = new Date(t);


  }
}



// WEBPACK FOOTER //
// ./src/BackendProxy.js